module.exports = __webpack_public_path__ + "img/31.3c7abaf2.png";